import { ArrowUp, ArrowDown, Minus, TrendingUp } from "lucide-react";

const LV = { below: "Building", on: "On grade", above: "Above grade" };

export const GrowthView = ({ growth, testId = "growth-view" }) => {
  if (!growth) return null;
  const rows = Object.entries(growth);
  const hasWinter = rows.some(([, g]) => g.winter);
  const hasSpring = rows.some(([, g]) => g.spring);
  return (
    <div className="mt-6 rounded-3xl bg-white/80 border border-[#E6DEC3] p-5" data-testid={testId}>
      <p className="font-display text-xl text-[#2C4A3E] inline-flex items-center gap-2"><TrendingUp className="w-5 h-5 text-[#C87D53]" /> Fall → Winter → Spring growth</p>
      {!hasWinter && !hasSpring && <p className="text-xs text-stone-500 mt-1">Mid-year check-in opens in January and end-of-year in May. Growth will appear here after them.</p>}
      <div className="mt-4 space-y-2">{rows.map(([sid, g]) => {
        const Icon = g.change > 0 ? ArrowUp : g.change < 0 ? ArrowDown : Minus;
        return (
          <div key={sid} className="grid grid-cols-2 sm:grid-cols-[1fr_auto_auto_auto_auto] items-center gap-3 text-sm" data-testid={`growth-row-${sid}`}>
            <span className="text-[#2C4A3E] font-medium">{g.name}</span>
            <span className="text-stone-500">Fall: {LV[g.fall]} ({g.fall_score}/5)</span>
            <span className="text-stone-500">{g.winter ? `Winter: ${LV[g.winter]} (${g.winter_score}/5)` : "Winter: -"}</span>
            <span className="text-stone-500" data-testid={`growth-spring-${sid}`}>{g.spring ? `Spring: ${LV[g.spring]} (${g.spring_score}/5)` : "Spring: -"}</span>
            <span className={`inline-flex items-center gap-1 ${g.change > 0 ? "text-[#6B9080]" : g.change < 0 ? "text-[#C87D53]" : "text-stone-400"}`}>
              {(g.winter || g.spring) && <Icon className="w-4 h-4" />}{g.levelups > 0 && <span className="text-xs px-2 py-0.5 rounded-full bg-[#F2D49B] text-[#5B3A1E]">{g.levelups} level-up{g.levelups > 1 ? "s" : ""}</span>}
            </span>
          </div>
        );
      })}</div>
    </div>
  );
};
